import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { standardCommand } from '../../../core/model/command';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ControlDataExportCommand } from '../../command/control-data-export.command';
import { ControlDataExportListItem } from '../../model/control-data/control-data-export-list-item';
import { ControlDataExportCommandHandlerResolver } from '../../service/command/Control-data-export-command-handler-resolver';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { CompanyService } from '../../service/data/company.service';
import { ControlDataExportListService } from '../../service/data/control-data-export.service';

@Component({
    selector: 'app-control-data-export-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [ControlDataExportCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControlDatExportManagerComponent extends PagedObjectManagerComponent<ControlDataExportListItem> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private readonly _dataService: ControlDataExportListService,
    private readonly _companyService: CompanyService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: ControlDataExportCommandHandlerResolver
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);

    this.allowNew = true;
    this.columnDefinition = columnDefinitionService.create('ControlDataExport');
    this.title = 'CONTROL_DATA.CONTROL_DATA_EXPORT';
    this.preferencesKey = 'rent.control-data-export.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'COMMON.COMPANY',
            'companyId',
            definition.companyId,
            this._companyService,
            definition.selectedFields.includes('companyId')
          ),
          new FilterDefinitionItem(
            'COMMON.INCOME_YEAR',
            'incomeYear',
            definition.incomeYear,
            null,
            definition.selectedFields.includes('incomeYear')
          ),
        ];
      })
    );

    this.addContextMenuItemDefinition('EDIT_BTN', standardCommand.edit);
    this.addContextMenuItemDefinition(
      'COOPERATIVE_HOUSING.KU55.CREATE_NEW_CONTROL_DATA',
      ControlDataExportCommand.generateNewControlDataFile
    );
  }
}
